<div class="d-flex flex-column flex-sm-row gap-2">
    <button class="btn btn-default flex-even w-100"
        *ngIf="newsDetails.documentLinkType == documentLinkTypeEnum.Document" (click)="openDocumentModal()">
        <i class="fa-solid fa-file"></i>
        {{'news.documentText' | transloco}}
    </button>

    <a class="btn btn-default flex-even  w-100" *ngIf="isValidUrl(newsDetails.documentLinkUrl)"
        [href]="newsDetails.documentLinkUrl" [target]="getTarget(newsDetails.documentLinkUrl!)">
        <i class="fa-solid fa-link"></i>
        {{'news.linkText' | transloco}}
    </a>

    <a class="btn btn-default flex-even  w-100" *ngIf="isValidUrl(newsDetails.link)" [href]="newsDetails.link"
        [target]="getTarget(newsDetails.link!)">
        <i class="fa-solid fa-link"></i>
        {{'news.linkText' | transloco}}
    </a>
</div>